function HighResolutionFull() {
    /// <summary>
    /// This object provides js functions for the Widget.Admin.DbSynch.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 31.5.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.04.2019                                               *<br />
    /// **********************************************************************<br />
    /// * - typing eror removed                                              *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 03.04.2019                                               *<br />
    /// **********************************************************************<br />
    /// * - bug fix, happend within the update-cycle when no signal was selected *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.07.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - added loading info                                              *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 29.6.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}

HighResolutionFull.prototype = new window.vcTemplate();

HighResolutionFull.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>

    var me = this;
    var w;
    var bIsHome;
    try {

        if (me.error) {
            return false;
        }
        bIsHome = false;
        me.showInfo("", "", false);
        
        me.menu.chart = $("#divChart");
        if (!me.menu.params) {
            me.menu.chart.height(parseInt(me.height - me.visual.find("#divMenu").height() - 15, 10));

            w = parseInt(me.width - me.visual.find("#divSignals").width() - 25, 10);
            me.menu.chart.width(w);
        } else {
            bIsHome = true;
            me.menu.chart.width(me.width - 50);
            me.menu.chart.height(parseInt(me.height));
        }
        me.vcVisual.addVisualBaseByName("divSi","VISUAL_SIGNAL_ANALOG_TOOLS_HIGH_RES_LIST","gnals",window.moment().format("DD.MM.YYYY"),parseInt(me.height - me.visual.find("#divMenu").height() - 30, 10),296,JSON.stringify({ "loadAll":false, "IsHome": bIsHome }),"",1);
        window._VCMQ.addConsumer('hrmen');
        window._VCMQ.consume($('#divMenu'), 'hrmen', function (event) { me.menu.doEvent(event); });
       
        me.menu.setHrMenuclickHandler();
        //second is vcgid
        me.menu.overrideShowButton($('#divChart'), 253);

        if (me.menu.params && me.menu.params.Signals && me.menu.params.Signals.length > 0) {

            me.menu.lstSignals = me.menu.params.Signals;
           
            me.dateObj = { "dateRange": { "from": window.moment(me.menu.params.StartDate, "DD.MM.YYYY").toDate().format("dd.MM.yyyy"), "to": window.moment(me.menu.params.EndDate, "DD.MM.YYYY").toDate().format("dd.MM.yyyy") } };

            window._VCMQ.produce($(me.visual), me.vcgid, "HR_MENU_DATE_CHANGE", { "dateRange": { "from": window.moment(me.menu.params.StartDate, "DD.MM.YYYY").toDate().format("dd.MM.yyyy"), "to": window.moment(me.menu.params.EndDate, "DD.MM.YYYY").toDate().format("dd.MM.yyyy") } });

        }
      
        me.menu.loadChart(me.menu.chart, 253);


        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }

};

HighResolutionFull.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find(".vc-list-table").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

function HrMenu(visual, vcid, vcgid) {
    /// <summary>
    /// This object does the complete menu and highchart handling in the sankey. <br/>
    /// It generates proper ramp and ramp signal parameters, does the date handling and menu hiding/showing stuff. 
    /// Author: MWI<br />
    /// Date: 29.11.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 29.11.2017                                              *<br />
    /// **********************************************************************<br />
    /// * -  inherited from rampMenu js                                      *<br />
    /// * -  changed only a few functions                                    *<br />
    /// **********************************************************************<br />
    /// </summary>
    ///<summary>
    ///creates the Object by simply calling the "super" constructor
    ///</summary>
    window.rampMenu.call(this, visual, vcid, vcgid);

    this.lstSignals = [];
    this.ChartDateFormat = "DD.MM.YYYY";
    this.updateDataParam = new Object();
    this.VCMQ_HR_MENU_MESSAGE_VISIBILITY = "HR_MENU_SET_VISIBILITY";
    this.VCMQ_HR_MENU_MESSAGE_DIRTY = "HR_MENU_SET_DIRTY";
    this.VCMQ_HR_MENU_MESSAGE_SHOW_MESSAGE = "HR_MENU_SHOW_MESSAGE";
    this.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR = "HR_MENU_SHOW_ERROR";
    this.VCMQ_HR_LIST_MESSAGE_HIDE = "HR_LIST_HIDE";
    this.VCMQ_HR_CHART_FINISHED_LOADING = "HRCHART_FINISHED_LOADING";
    this.VCMQ_HR_MENU_TEST_UP_TO_DATE = "HR_MENU_TEST_UP_TO_DATE";
    this.VCMQ_NEW_LOADING = "HR_NEW_LOADING";
    this.DATE_PICKER_ID = "#high-res-dates";
    this.DELETE_BUTTON_ID = "#btnDeleteHr";

    this.chartHeight = 750;
    this.elementCount = -1;
    this.iChartUpdateInterval = 10;  //fix every 10 seconds
    this.transmissionTime = 300;   //fix to 5 minutes
    //this.UPDATE_TYPE_REFRESH_CHART = 1;
    //this.UPDATE_TYPE_GET_ELEMENT_COUNT = 2;
};

//create the prototype based on the rampMenu Object
HrMenu.prototype = Object.create(window.rampMenu.prototype);

//set the constructor to this object
HrMenu.prototype.constructor = HrMenu;


//FUNCTIONS HAVE TO START AFTER THE CONSTRUCTOR
HrMenu.prototype.setHrMenuclickHandler = function () {
    ///<summary>
    /// This function creates the click/change handler for the hrMenu elements
    ///</summary>
    var me = this;
    var from, to;
    try {

        from = window.moment().toDate().format("dd.MM.yyyy");
        to = window.moment().toDate().format("dd.MM.yyyy");
        window._VCMQ.produce($(me.visual), me.vcgid, "HR_MENU_DATE_CHANGE", { "dateRange": { "from": from, "to": to } });
        if (me.params) {

            from = window.moment(me.params.StartDate,"DD.MM.YYYY").toDate().format("dd.MM.yyyy");
            to = window.moment(me.params.EndDate,"DD.MM.YYYY").toDate().format("dd.MM.yyyy");
        }



        me.visual.find(me.DATE_PICKER_ID).vcDateBox({ "mode": "Range", "interval": 1, langID: me.userLangidForCulture, defaultRange: { "from": from, "to": to }, "align": "right", "callback": function (obj) { me.onDateChanged(obj); } });
        me.visual.find(me.DELETE_BUTTON_ID).off("click").on("click", function () { me.prepareDeleteDialog(253); });
    } catch (ex) {
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
        window.writeError('HrMenu.setHrMenuclickHandler', ex);
    }
};


HrMenu.prototype.prepareDeleteDialog = function (vcgid) {
    var me = this;
    var sDialogText ;
    var tmpVCTemplate;
    var tmpUpdateParameter;
    try {
        if (me.visual.find(me.DELETE_BUTTON_ID).hasClass("active")) {
            tmpVCTemplate = new window.vcTemplate();
            me.generateChartParameter();
            tmpUpdateParameter = JSON.parse(me.updateDataParam);

            sDialogText = "<span style='font-weight:bold;font-size:larger'>" + me.resources.deletePeriod + "</span>";
            sDialogText += "<br/><br/>&#9873 " + tmpUpdateParameter.Bsaids.length + " " + me.resources.signals + "!";
            sDialogText += "<br/><br/>&#9873 " +
                me.resources.period +
                " <span style='font-weight:bold;'> " +
                window.moment(tmpUpdateParameter.StartDate).format("DD.MM.YYYY") +
                " - " +
                window.moment(tmpUpdateParameter.EndDate).format("DD.MM.YYYY") +
                "</span>";
            sDialogText += "<br/><br/><span style='font-weight:bold;'> " + me.resources.tip_delete + "</span>";

            tmpVCTemplate.resources.yes = me.resources.yes;
            tmpVCTemplate.resources.no = me.resources.no;
            tmpVCTemplate.openAskDialog(sDialogText, "", function () { me.deleteData(vcgid); });
        }
    } catch (ex) {
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
        window.writeError('HrMenu.prepareDeleteDialog', ex);
    }
};

// ReSharper disable once UnusedParameter
HrMenu.prototype.onDateChanged = function (dateObj) {
    ///<summary>
    /// This takes the callback  from the vcdate when the date gets changed <br/>
    /// only sets the reload button to dirty
    ///</summary>
    var me = this;
    try {
        me.dateObj = dateObj;
        me.setDirty(true);
        window._VCMQ.produce($(me.visual), me.vcgid, "HR_MENU_DATE_CHANGE", { dateRange: me.dateObj.dateRange });

    } catch (ex) {
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
        window.writeError('HrMenu.onDateChanged', ex);
    }
};
HrMenu.prototype.overrideShowButton = function (chartDiv, vcgid) {
    ///<summary>
    /// This function changes the standard rampMenu functionality of the showChartButton with the specific functionality needed here
    ///</summary>
    var me = this;
    try {
        me.chart = chartDiv;
        me.visual.find("#btnShowChart").off("click").on("click", function () {
            if ($(this).hasClass("active")) {
                clearTimeout(me.timeoutId);
                me.visual.find("#high-res-reload").off("click").show().html(me.resources.highResolutionloading).addClass("loading note").removeClass("new-data");
                //reset to start anew
                me.elementCount = -1;
                //checks if the div has the class attribute and a class starting with high res
                $("#ul-lst-signals .vc-list-item.selected .list-refresh-text div[class*='high-res']").empty();
                $(".hr-signal-color").css({ "background-color": "transparent" });
                $("#ul-lst-signals .vc-list-item").data("hasHrValues", false);
                window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_NEW_LOADING, "");
                me.loadChart(chartDiv, vcgid);

            }
        });
    } catch (ex) {
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
        window.writeError('HrMenu.overrideShowButton', ex);
    }
};
HrMenu.prototype.generateChartParameter = function () {
    ///<summary>
    /// This function is an overload of the rampMenu generateChartParameter and prepares the parameters for the chart and the update call
    ///</summary>
    var me = this;
    var bRet = false;
    var dtDates;

    try {
        dtDates = me.dateObj.dateRange;
        me.param = {
            StartDate: dtDates.from,
            EndDate: dtDates.to,
            NoZoom: false,
            ShowExportIcons: true, 
            HighResolutionQualityLevel:parseInt(me.visual.find("#ddl-select").val())
        };
        me.signalParam = { 'series': [] };


        me.lstSignals.forEach(function (element) {
            me.signalParam.series.push({ 'bsaid': [element] });
        });
        me.updateDataParam = JSON.stringify({
            'updateType': me.UPDATE_TYPE_REFRESH_CHART,
            'taskType': me._TASK_TYPE_NONE,
            'TransmissionTime': me.transmissionTime,
            'Bsaids': me.lstSignals,
            'StartDate': window.moment(dtDates.from, "DD.MM.YYYY").toDate(),
            'EndDate': window.moment(dtDates.to, "DD.MM.YYYY").toDate()
        });
       
        bRet = true;
    } catch (ex) {
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
        window.writeError('HrMenu.generateChartParameter', ex);
    }
    return bRet;
};
HrMenu.prototype.validateChartParameter = function () {
    ///<summary>
    /// This function validates the parameter in the menu for their correctness before sending them to the server
    ///</summary>
    var me = this;
    var bRet = false;
    var iTransMissionTime;
    var dtDates;
    try {

        dtDates = me.dateObj.dateRange;
        iTransMissionTime = 5;
        bRet = window.moment(dtDates.from, me.ChartDateFormat).isValid() &&
            window.moment(dtDates.to, me.ChartDateFormat).isValid() &&
            isNaN(iTransMissionTime) === false &&
            iTransMissionTime > 0 &&
            me.lstSignals.length >= 1;
    } catch (ex) {
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
        window.writeError('HrMenu.validateChartParameter', ex);
    }
    return bRet;
};
HrMenu.prototype.updateDataResult = function (result, isDelete) {
    ///<summary>
    /// This function is a callback for the updateData call in the loadChart function
    ///</summary>
    ///<param name='result'>the value coming from the server if the task was sucessfully sent</param>
    ///<param name='isDelete'> sees whether this was a deletion call </param>
    var me = this;
    try {
        if (result.HasError === false) {
            if (!me.params) {
                window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_MESSAGE, { useTimeout: true, message: result.RetHTML });
            }
            setTimeout(function () { me.visual.find("#info").invisible(); }, 5000);
            if (isDelete === false) {
                window.VisualCoreService.getVisualContentByName("VISUAL_CHART_HR_ONLINE", me.vcvid, window.getCurrentTimestamp(), parseInt(me.chart.height(), 10), parseInt(me.chart.width(), 10), JSON.stringify(me.param), JSON.stringify(me.signalParam), 1,
                    function (result) {
                        me.chart.html(result);
                        me.setDirty(false);
                    });
            }
        } else {
            //window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_LIST_MESSAGE_HIDE, "");
            window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, { useTimeout: true, message: result.RetHTML });
        }

    } catch (ex) {
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
        window.writeError('HrMenu.updateDataResult', ex);
    }
};


HrMenu.prototype.loadChart = function (chart, vcgid) {
    /// <summary>
    /// This function loads the current element widget 
    /// </summary>
    ///<param name='element'> the element to the widget for has to contain a data-id </param>   
    var me = this;
    var tmpUpdateParam;
    try {
        if (me.error) {
            return;
        }

        if (me.validateChartParameter() && me.generateChartParameter()) {
         
            me.chart = chart;
            me.vcvid = vcgid;
            me.isUpToDate = false;
            $("#ul-lst-signals .vc-list-item.selected .list-refresh-text").show();

            //me.chart.html(me.resources.icon_loading);
          //  if (!me.params) {
                window._VCMQ.produce($(me.visual),
                    me.vcgid,
                    me.VCMQ_HR_MENU_MESSAGE_SHOW_MESSAGE,
                    { useTimeout: true, message: me.resources.loading });
         //   }
            tmpUpdateParam = JSON.parse(me.updateDataParam);
            tmpUpdateParam.taskType = me._TASK_TYPE_SEND_ONLINE;
            window.VisualCoreService.updateData(vcgid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(tmpUpdateParam), function (result) {
                me.updateDataResult(result, false);
            });

            me.visual.find("#hr-updates-to").html(window.moment().add(me.transmissionTime, "seconds").format("HH:mm:ss"));

        } else {
            $("#ul-lst-signals .vc-list-item .list-refresh-text").hide();
            me.visual.find("#div-updates").hide();

            if ($("#ul-lst-signals .vc-list-item").length > 0) {
                if (!me.params) {
                    window._VCMQ.produce($(me.visual),
                        me.vcgid,
                        me.VCMQ_HR_MENU_MESSAGE_SHOW_MESSAGE,
                        { useTimeout: true, message: me.resources.noSignalSelected });
                }
            } else {


                window._VCMQ.produce($(me.visual),
                    me.vcgid,
                    me.VCMQ_HR_MENU_MESSAGE_SHOW_MESSAGE,
                    { useTimeout: true, message: me.resources.noData });
            }
        }
        
        setTimeout(function () { me.eventMessageChartFinishedLoading(); }, 60 * 1000);

    } catch (ex) {
        window.writeError('HrMenu.loadChart', ex);
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
    }
};



HrMenu.prototype.deleteData = function (vcvid) {
    /// <summary>
    /// This function loads the current element widget 
    /// </summary>
    ///<param name='element'> the element to the widget for has to contain a data-id </param>   
    var me = this;
    var tmpUpdateParam;
    try {
        if (me.error) {
            return;
        }
        if (me.validateChartParameter() && vcvid) {
            //$("#ul-lst-signals .vc-list-item.selected .list-refresh-text").show();
            tmpUpdateParam = JSON.parse(me.updateDataParam);
            tmpUpdateParam.taskType = me._TASK_TYPE_DELETE_HR;
            window.VisualCoreService.updateData(vcvid, vcvid, window.getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(tmpUpdateParam), function (result) {
                me.updateDataResult(result, true);
            });
        } else {
            $("#ul-lst-signals .vc-list-item .list-refresh-text").hide();
            me.visual.find("#div-updates").hide();
            window._VCMQ.produce($(me.visual), vcvid, me.VCMQ_HR_MENU_MESSAGE_SHOW_MESSAGE, { useTimeout: true, message: me.resources.noSignalSelected });
        }
    } catch (ex) {
        window.writeError('HrMenu.deleteData', ex);
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
    }
};


HrMenu.prototype.toggleVisibility = function (bDisplay) {
    /// <summary>
    /// just a wrapper for the normal toggle <br/>
    /// </summary>
    ///<param name='event'>whether to show or hide the menu</param>
    var me = this;
    try {
        me.visual.find('.bottommenu').toggle(bDisplay);
    } catch (ex) {
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
        window.writeError('HrMenu.toggleVisibility', ex);
    }
};
HrMenu.prototype.initUserOptions = function () {
    ///<summary>
    ///empty user options function to avoid errors
    ///</summary>
};
HrMenu.prototype.checkUpToDate = function () {
    ///<summary>
    /// This function is called when the HR-Chart and checks whether the latest values are available
    ///</summary>
    var me = this;
    try {
        me.isUpToDate = false;
        if (me.error) {
            me.isUpToDate = false;
        } else {
            me.isUpToDate = $("#ul-lst-signals .vc-list-item.selected").data("hasHrValues") !== undefined &&
                $("#ul-lst-signals .vc-list-item.selected .list-refresh-text .high-res-list-status-icon.high-res-missing").length !== 0;
        }
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
        window.writeError("HrMenu.checkUpToDate", ex);
        me.isUpToDate = false;
    }
    return me.isUpToDate;

};
HrMenu.prototype.setDirty = function (bSet) {
    /// <summary>
    /// This function sets the dirty state - used for refreshing info.
    /// </summary>
    var me = this;
    try {
        me.dirty = bSet;
        if ($("#ul-lst-signals .vc-list-item.selected").length > 0) {
            me.visual.find("#btnShowChart, " + me.DELETE_BUTTON_ID).toggleClass("active", true);
            me.visual.find("#btnShowChart, " + me.DELETE_BUTTON_ID).toggleClass("inactive", false);
            if (me.dirty) {
                me.visual.find("#btnShowChart").html("<i class='fa fa-sync-alt'></i><br />" + me.resources.reload);
            } else {
                me.visual.find("#btnShowChart").html("<i class='fa fa-check'></i><br />" + me.resources.loaded);
            }
        } else {
            me.visual.find("#btnShowChart, " + me.DELETE_BUTTON_ID).toggleClass("active", false);
            me.visual.find("#btnShowChart, " + me.DELETE_BUTTON_ID).toggleClass("inactive", true);

        }
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        window.writeError('HrMenu.js.setDirty', ex);
    }

};
HrMenu.prototype.eventMessageDirty = function (event) {
    ///<summary>
    ///this function is called by the doEvent function when the Event Message is <see cref="me.VCMQ_HR_MENU_MESSAGE_DIRTY"/> <br/>
    /// it sets the btnShowCharet to dirty and updates the list of signals used
    ///</summary>
    var me = this;
    var index;
    try {
        index = me.lstSignals.indexOf(event.values.signalid);
        me.setDirty(event.values.isDirty);
        if (event.values.signalAdded === true && index === -1) {
            me.lstSignals.push(event.values.signalid);
        } else if (event.values.signalAdded === false) {
            if (index > -1) {
                me.lstSignals.splice(index, 1);
            }
        }
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        window.writeError('HrMenu.js.eventMessageDirty', ex);
    }
};
HrMenu.prototype.eventMessageShowMessage = function (event) {
    ///<summary>
    ///this function is called by the doEvent function when the Event Message is <see cref="me.VCMQ_SHOW_MESSAGE"/> <br/>
    /// it sets the btnShowCharet to dirty and updates the list of signals used
    ///</summary>
    var me = this;
    try {
        if (event.values.useTimeout) {
            setTimeout(function () { me.visual.find("#info").invisible(); }, 5000);
        }
        if (event.values.setZeroMargin) {
            me.chart.css({ "left": 0 });
            me.visual.height(0);
        }
        if (event.values.setStyledMessage) {
            me.chart.html("<div class='ui-corner-all ui-state-error vc-error-no-data'>" + event.values.message + "</div>");
        } else {
            if (event.values.message.startsWith("<i") === false) {
                me.chart.html(
                    "<div id='info' ><div class='note'><span class='main'>" +
                    event.values.message +
                    "</span><br><span class='sub'></span></div></div>");
            } else {
                  me.chart.html(event.values.message);
            }
        }
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        window.writeError('HrMenu.js.eventMessageShowMessage', ex);
    }
};
HrMenu.prototype.eventMessageShowError = function (event) {
    ///<summary>
    ///this function is called by the doEvent function when the Event Message is <see cref="me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR"/> <br/>
    /// it basically hides the whole widget and shows an error message
    ///</summary>
    var me = this;
    // ReSharper disable once AssignedValueIsNeverUsed
    var message = "";
    try {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_LIST_MESSAGE_HIDE, "");
        me.chart.css({ "left": 0 });
        me.visual.height(0);
        if (event.values.message && event.values.message.length > 0) {
            message = event.values.message;
        } else {
            message = me.resources.codeError;
        }
        me.chart.html("<div id='info'><div class='error'><span class='main'>" + message + "</span><br><span class='sub'>" + me.resources.subInfo + "</span></div></div>");
        me.toggleVisibility(false);
    } catch (ex) {
        //no error message here otherwise in case of an error we would probably run into an endless loop
        //window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        window.writeError('HrMenu.js.eventMessageShowError', ex);
    }
};
HrMenu.prototype.eventMessageTestUpToDate = function () {
    ///<summary>
    ///this function is called by the doEvent function when the Event Message is <see cref="me.VCMQ_HR_MENU_TEST_UP_TO_DATE"/> <br/>
    /// it checks the data in the lists and sees if it is available and up to date 
    ///</summary>
    var me = this;
    var hasDataTest;
    try {
        if (me.checkUpToDate()===false) {
            hasDataTest = $("#ul-lst-signals .vc-list-item.selected").filter(function (ix, element) {
                return $(element).data("hasHrValues") === undefined ||
                    $(element).data("hasHrValues") === false;
            });
            //set all elements individually to no data
            if (hasDataTest.length > 0) {
                hasDataTest.find(".high-res-last-signal-timestamp").html(me.resources.noData);
            }
            // if every selected element has data show the info
            if (hasDataTest.length === me.lstSignals.length) {
                $("#div-chart").append("<div id='hr-chart-no-data' class='hr-chart-info note'>" + me.resources.noData + "</div>");
            } else {
                $("#div-chart #hr-chart-no-data").remove();
            }
        }
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        window.writeError('HrMenu.js.eventMessageTestUpToDate', ex);
    }
};
HrMenu.prototype.eventMessageChartFinishedLoading = function () {
    ///<summary>
    ///this function is called by the doEvent function when the Event Message is <see cref="me.VCMQ_HR_CHART_FINISHED_LOADING"/> <br/>
    /// it calls the webservice to check how many elements are available 
    ///</summary>
    var me = this;
    var testParams;
    try {
        me.generateChartParameter();
        testParams = JSON.parse(me.updateDataParam);
        testParams.updateType = me.UPDATE_TYPE_GET_ELEMENT_COUNT;
        testParams.startdate = window.moment(me.param.StartDate, "DD.MM.YYYY").utcOffset(new Date().getTimezoneOffset()).toDate();
        testParams.enddate = window.moment(me.param.EndDate, "DD.MM.YYYY").utcOffset(new Date().getTimezoneOffset()).toDate();

        clearTimeout(me.timeoutId);
        //check if any signal is selected -- can happen if I want to select new signals
        if (testParams.Bsaids && testParams.Bsaids.length > 0) {
             window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(testParams), function (result) { me.wsCallCountElementReturn(result); });
        }
    } catch (ex) {

        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        window.writeError('HrMenu.js.eventMessageChartFinishedLoading', ex);
    }
};
HrMenu.prototype.wsCallCountElementReturn = function (result) {
    ///<summary>
    ///this function is the webservice return function upon request how many elements are available
    /// it stores the the amount in an variable and if more elements are available than previously stored it creates an info message <br/>
    /// usually calls itself after <see cref="me.iChartUpdateInterval"/> (default: 20) seconds again with a faked     <see cref="me.VCMQ_HR_CHART_FINISHED_LOADING"/> message
    ///</summary>
    var me = this;
    var count;
    try {
        count = parseInt(result.RetHTML, 10);
        if (result.HasError === true || count === -1) {
            window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, { useTimeout: true, message: me.resources.codeError });
        } else {
            if (count === 0) {
                $("#div-chart").append("<div id='hr-chart-no-data' class='hr-chart-info note'>" + me.resources.noData + "</div>");
            }
            if (me.elementCount === -1) {
                me.elementCount = count;
            }
            if (me.elementCount < count) {
                me.elementCount = count;
                me.visual.find("#high-res-reload").off("click").on("click", function () { me.visual.find("#btnShowChart").trigger("click"); }).removeClass("loading note").addClass("new-data").html("<div class='high-res-reload-info-icon'><i class='fa fa-info fa-5x icon-color-info'></i></div><div class='high-res-reload-info-text'>" + me.resources.newHighResolutionData + "</div>");

            } else {
                //me.visual.find("#high-res-reload:not(.loading)").off("click");
                if (me.visual.find("#high-res-reload.new-data").length !== 1) {
                    me.visual.find("#high-res-reload").addClass("loading note").removeClass("new-data")
                        .html(me.resources.highResolutionloading);
                }

            }
            clearTimeout(me.timeoutId);

            me.timeoutId = setTimeout(function () {
                window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_CHART_FINISHED_LOADING, "");
            }, me.iChartUpdateInterval * 1000
            );
        }
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        window.writeError('HrMenu.js.wsCallCountElementReturn', ex);
    }
};
HrMenu.prototype.doEvent = function (event) {
    /// <summary>
    /// This function gets all event messages and acts accordingly <br/>
    /// i.e.calls the appropriate functions based on the event.msg
    /// </summary>
    ///<param name='event'>the event that is used while calling this function</param>
    var me = this;
    try {
        switch (event.msg) {

            case me.VCMQ_HR_MENU_MESSAGE_VISIBILITY:
                if (!me.params) {
                    window._VCMQ.produce($(me.visual),
                        me.vcgid,
                        me.VCMQ_HR_MENU_MESSAGE_SHOW_MESSAGE,
                        { useTimeout: true, message: me.resources.noSignalSelected });
                } 
                me.toggleVisibility(event.values.bDisplay);
                break;
            case me.VCMQ_HR_MENU_MESSAGE_DIRTY:
                me.eventMessageDirty(event);
                break;
            case me.VCMQ_HR_MENU_MESSAGE_SHOW_MESSAGE:
                me.eventMessageShowMessage(event);
                break;
            case me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR:
                me.eventMessageShowError(event);
                break;
            case me.VCMQ_HR_MENU_TEST_UP_TO_DATE:
                me.eventMessageTestUpToDate();
                break;
            case me.VCMQ_HR_CHART_FINISHED_LOADING:
                me.eventMessageChartFinishedLoading();
                break;
            default:
                break;
        }
    } catch (ex) {
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        me.showInfo(me.resources.codeError, me.resources.subInfo, true);
        window.writeError('HrMenu.doEvent', ex);
    }
};
HrMenu.prototype.showInfo = function (content, subcontent, bError) {
    /// <summary>
    /// This function extends the basic showMessage() function with optional subcontent and specific style..
    /// </summary>
    var me = this;
    try {
        if (content.length === 0) {
            me.visual.find('#info').invisible();
            me.visual.find('#info div').removeClass('note').removeClass('error').invisible();
            return true;
        }
        me.visual.find('#info').visible();
        content = "<span class='main'>" + content + "</span><br/><span class='sub'>" + subcontent + "</span>";
        me.visual.find('#info div').html(content);


        if (bError) {
            me.visual.find('#info div').removeClass('note').addClass('error').visible();
        } else {
            me.visual.find('#info div').removeClass('error').addClass('note').html(content);
        }
        return true;
    } catch (ex) {
        me.toggleVisibility(false);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_HR_MENU_MESSAGE_SHOW_ERROR, "");
        window.writeError('HrMenu.showMessage', ex);
        return false;
    }
};

jQuery.fn.visible = function () {
    return this.css('visibility', 'visible');
};

jQuery.fn.invisible = function () {
    return this.css('visibility', 'hidden');
};

function HighResList() {
    /// <summary>
    /// This object provides js functions for the SignalSelection Lists <br/>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 28.6.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 28.6.2017                                            *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.VCMQ_SEND_MESSAGE_DIRTY = "HR_MENU_SET_DIRTY";
    this.VCMQ_SEND_MESSAGE_ERROR = "HR_MENU_SHOW_ERROR";
    this.VCMQ_SEND_MESSAGE_VISIBILTY = "HR_MENU_SET_VISIBILITY";
    this.VCMQ_SEND_MESSAGE_SHOW_MESSAGE = "HR_MENU_SHOW_MESSAGE";
    this.VCMQ_REC_MESSAGE_HIDE = "HR_LIST_HIDE";
    this.VCMQ_DATE_CHANGED = "HR_MENU_DATE_CHANGE";
    this.VCMQ_HR_MENU_TEST_UP_TO_DATE = "HR_MENU_TEST_UP_TO_DATE";
    this.VCMQ_HR_CHART_FINISHED = "HRCHART_FINISHED_LOADING";
    this.VCMQ_NEW_LOADING = "HR_NEW_LOADING";
    this.iHrValidTolerance = 2;
    this.iChartUpdateInterval = 20;
}
HighResList.prototype = new window.vcTemplate();
HighResList.prototype.init = function () {
    /// <summary>
    /// This function inits the signal selection menu 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);
        me.visual.find('.vc-list').height(me.visual.height() - 2);

        ////init the filter events
        me.visual.find("#div-signal-filter").vcFilter({ callback: function () { me.filter(); } });
        me.loadItems(-1);

        return true;
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
        me.writeError("HighResList.init", ex);
        return false;
    }

};

HighResList.prototype.loadFirstInList = function (id) {
    /// <summary>
    /// If implemented this function loads the first item in the selection list
    /// </summary>
    var me = this;
    try {

        if (id !== -0x1) {
            me.visual.find("#ul-lst-signals .vc-list-item[data-id='" + id + "']").trigger("click");
        } else {

            me.visual.find("#ul-lst-signals .vc-list-item").trigger("click");
            $("#btnShowChart").trigger("click");
        }
    } catch (ex) {
        me.writeError("HighResList.loadFirstInList", ex);
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
    }
};
HighResList.prototype.addSpecificClickHandler = function () {
    /// <summary>
    /// This function inits the assigment specific icons if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        me.visual.find("#ul-lst-signals .vc-list-item").off("click").on("click", function () {
            $(this).toggleClass("selected");
            $(this).find(".hr-signal-color").css({ "background-color": "transparent" });
            $(this).data("hasHrValues", true);
            $(this).find(".list-refresh-text").toggle();
            $(this).find(".high-res-last-signal-value,.high-res-last-signal-timestamp, .high-res-list-status-icon").html("");
            window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_DIRTY, { isDirty: true, signalAdded: $(this).hasClass("selected"), signalid: parseInt($(this).data("id"), 10) });
        });

        me.visual.find("#chb-hr-signal-selection").off("change").on("change", function () {
            if (this.checked) {
                me.visual.find(".vc-list-item.found:not(.selected)").each(function () { $(this).trigger("click"); });
            } else {
                me.visual.find(".vc-list-item.found.selected").each(function () { $(this).trigger("click") });
            }
        });
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
        me.writeError("HighResList.addSpecificClickHandler", ex);
    }
};
HighResList.prototype.addAssignmentItemSpecifics = function () {
    /// <summary>
    /// This function inits the assigment specific html if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    var sTmp = "";
    try {
        if (me.error) {
            return false;
        }
        sTmp += "<div class='hr-signal-color'></div>";
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
        me.writeError("signalSelectinList.addAssignmentmentItemSpecifics", ex);
        sTmp = "";
    }
    return sTmp;

};
HighResList.prototype.loadItems = function (id) {
    /// <summary>
    /// This function loads all entries for the selected item and fills the sortable lists 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.assID = id;
        me.visual.find("#ul-lst-signals").html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, me.parameter, '', me.deviceType, me.langid, "", function (result) { me.setResultItems(result, id); });

        return true;
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
        me.writeError("HighResList.loadItems", ex);
        return false;
    }

};
HighResList.prototype.setUpToDateText = function (id, lastDate, lastVal) {
    ///<summary>
    /// This function is called when the HR-Chart gets updated and sets the icons to state whether the values are up to date
    ///</summary>
    var me = this;
    var resolution;
    var currentTime, lastTime;

    try {
        if (me.error) { return false; }

        if (lastDate !== undefined && window.moment(lastDate).isValid()) {
            resolution = parseInt(me.visual.find("#ul-lst-signals .vc-list-item.selected[data-id=" + id + "]").data("res"), 10);
            currentTime = (new Date).getTime();
            lastTime = window.moment.parseZone(lastDate);

            if (me.selectedDate === undefined) {
                me.selectedDate = new Object();
                me.selectedDate.from = window.moment().add(-1, "days").toDate().format("dd.MM.yyyy");
                me.selectedDate.to = window.moment().toDate().format("dd.MM.yyyy");
            }
            if (window.moment(me.selectedDate.to, "DD.MM.YYYY").isBefore(window.moment(), "day")) {
                currentTime = window.moment(me.selectedDate.to, "DD.MM.YYYY").add(1, "days").add(-1, "s");
            }

            if (Math.abs(lastTime.diff(currentTime, 'seconds')) > resolution * me.iHrValidTolerance) {
                me.visual.find("#ul-lst-signals .vc-list-item.selected[data-id=" + id + "] .list-refresh-text .high-res-list-status-icon").removeClass("high-res-complete").addClass("high-res-missing").html(me.resources.icon_missing_data);
            } else {
                me.visual.find("#ul-lst-signals .vc-list-item.selected[data-id=" + id + "] .list-refresh-text .high-res-list-status-icon").removeClass("high-res-missing").addClass("high-res-complete").html(me.resources.icon_ok);
            }
            me.visual.find("#ul-lst-signals .vc-list-item.selected[data-id=" + id + "] .list-refresh-text .high-res-last-signal-timestamp").html(lastTime.format("DD.MM.YYYY HH:mm:ss"));
            me.visual.find("#ul-lst-signals .vc-list-item.selected[data-id=" + id + "] .list-refresh-text .high-res-last-signal-value").html(lastVal).formatDouble(2);
            me.visual.find("#ul-lst-signals .vc-list-item.selected[data-id=" + id + "]").data("hasHrValues", true);
        } else {
            me.visual.find("#ul-lst-signals .vc-list-item.selected[data-id=" + id + "] .list-refresh-text .high-res-list-status-icon").removeClass("high-res-complete").addClass("high-res-missing").html(me.resources.icon_missing_data);
        }

        return true;
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
        window.writeError("HighResList.setUpToDateText", ex);
        return false;
    }

};
HighResList.prototype.setColor = function (id, color) {
    ///<summary>
    /// This function is called when the HR-Chart gets updated and sets the appropriate chart color for each signal
    ///</summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.find("#ul-lst-signals .vc-list-item[data-id=" + id + "] .hr-signal-color").css({ "background-color": color });
        return true;
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();

        me.writeError("HighResList.setColor", ex);
        return false;
    }

};
HighResList.prototype.setResultItems = function (result, id) {
    /// <summary>
    /// This function sets the entries got from the webservice request and fills the list
    /// </summary>
    var sTmp = "";
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        if (result === null) {
            window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_VISIBILTY, { bDisplay: false });
            window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_SHOW_MESSAGE, { setStyledMessage: true, setZeroMargin: true, useTimeout: false, message: me.resources.noData });
            me.visual.hide();
            return false;
        }
        if (result.rows === null) {
            window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_VISIBILTY, { bDisplay: false });
            window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_SHOW_MESSAGE, { setStyledMessage: true, setZeroMargin: true, useTimeout: false, message: me.resources.noData });
            me.visual.hide();
            return false;
        } else {
            window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_VISIBILTY, { bDisplay: true });
            me.visual.show();
        }
        if (JSON.parse(me.parameter).IsHome === false) {
            me.visual.find("#ul-lst-signals").html("");
            for (var i = 0; i < result.rows.length; i++) {
                sTmp += "<li class='vc-list-item found";
                if (i % 2 === 0) {
                    sTmp += " alt ";
                }
                if (result.rows[i].active === false) {
                    sTmp += " inactive";
                }
                sTmp += "' data-id='" + result.rows[i].bsaid + "' data-res='" + result.rows[i].len + "'>";
                sTmp += me.addAssignmentItemSpecifics(result.rows[i]);
                sTmp += "<div class='list-main-text' style='float:left;'>" + result.rows[i].name;
                //sTmp += "<span class='high-res-signal-res' >(" + result.rows[i].len + " s" + ")</span>";

                sTmp += "</div>";
                sTmp += "<div class='list-refresh-text'>" +
                    "<div class='high-res-list-status-icon high-res-loading'></div>" +
                    "<div class='high-res-last-signal-value'></div>" +
                    " <div class='high-res-last-signal-timestamp'></div>" +
                    "</div>";

                sTmp += "</li>";

            }
            me.visual.find("#ul-lst-signals").html(sTmp);
            me.addSpecificClickHandler(id);
            if (me.parameter && JSON.parse(me.parameter).loadAll === true) {
                me.loadFirstInList(-1);
            }
        }

    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
        me.writeError("HighResList.setResultItems", ex);

    }
    return true;
};
HighResList.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#div-signal-list").hide();
        }
        return true;
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
        me.writeError('HighResList.specificInfoHandling', ex);
        return false;
    }
};

HighResList.prototype.doEvent = function (event) {
    /// <summary>
    /// This function  handles incoming messages 
    /// </summary>
    var me = this;
    try {

        if (me.error) {
            return false;
        }
        switch (event.msg) {


            //view Event
            case me.VCMQ_toggle_list_update_message:
                me.visual.find("#ul-lst-signals .vc-list-item .hr-signal-color").css({ "background-color": "transparent" });
                me.visual.find("#ul-lst-signals .vc-list-item.selected").data("hasHrValues", false);

                for (var i = 0; i <= event.values.length - 1; i++) {
                    me.setColor(event.values[i].bsaid, event.values[i].color);
                    me.setUpToDateText(event.values[i].bsaid, event.values[i].lastDate, event.values[i].lastVal);
                }
                me.visual.find("#ul-lst-signals .vc-list-item.selected").filter(function (ix, element) {
                    return $(element).data("hasHrValues") === false;
                }).find(".high-res-last-signal-timestamp").html(me.resources.noData);
                window._VCMQ.produce($(me.visual), me.vcgid, this.VCMQ_HR_MENU_TEST_UP_TO_DATE, "");

                break;
            case me.VCMQ_REC_MESSAGE_HIDE:
                me.visual.hide();
                break;
            case me.VCMQ_DATE_CHANGED:
                me.selectedDate = event.values.dateRange;
                break;
            case me.VCMQ_HR_CHART_FINISHED:

                me.loadingFinished = true;
                break;

            case me.VCMQ_NEW_LOADING:
                me.loadingFinished = false;
                break;
            default:
                break;
        }
        return true;
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
        me.writeError("HighResList.doEvent", ex);
        return false;
    }
};
HighResList.prototype.filter = function () {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //hide all
        me.visual.find(".vc-list-table .vc-list-item").removeClass("found").data("counter", 0).hide();
        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "found");

        me.visual.find(".vc-list-table .vc-list-item.found").show();
        me.visual.find(".vc-list-table .vc-list-item").removeClass("alt");
        me.visual.find(".vc-list-table .vc-list-item.found:even").addClass("alt");
        return true;
    } catch (ex) {
        window._VCMQ.produce($(me.visual), me.vcgid, me.VCMQ_SEND_MESSAGE_ERROR, "");
        me.visual.hide();
        me.writeError("HighResList.filter", ex);
        return false;
    }

}